<mat-form-field class="last-editor-form-field">
  <mat-label>LAST EDITOR</mat-label>
  <input
    matInput
    readonly
    class="last-editor-input"
    [class.has-logs]="hasLogs"
    [value]="displayValue"
    (click)="openLog()"
  />
</mat-form-field>
